import { gql } from "@apollo/client"

export const GET_VEHICLE_SUBSCRIPTION = gql`
    subscription Subscription($vehicleId: ID!) {
        vehicle(id: $vehicleId) {
            shifts {
                jobs {
                    jobId
                    grouping {
                        groupId
                        type
                    }
                }
            }
        }
    }
`

export const TRACKING_ENTITY_STATUS_SUBSCRIPTION = gql`
    subscription TrackEntityStatus($trackingEntityId: ID!) {
        trackingEntityStatus(trackingEntityId: $trackingEntityId) {
            trackingEntityId
            online
        }
    }
`
